import {useQuery} from '@tanstack/react-query'
import {fetchExpenseSummary} from '@/helpers/expenseDashboardHelper'
import {ExpenseSummary} from '@/components/expense-dashboard/expense-dashboard'

export const useExpenseSummary = (userEmail: string | null, hostURL?: {origin: string} | null) => {
    return useQuery<ExpenseSummary, Error>(
        ['expenseSummary', userEmail],
        () => fetchExpenseSummary(userEmail, hostURL),
        {
            enabled: !!userEmail,
            onError: (error) => {
                console.error('Error fetching expense summary:', error)
            }
        }
    )
}
